import React from 'react';

export default function sectionProgress({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="15.748"
      height="3.937"
      data-name="Group 64"
      viewBox="0 0 15.748 3.937"
    >
      <g fill="#fff" data-name="Group 17">
        <circle cx="1.968" cy="1.968" r="1.968" data-name="Ellipse 63"></circle>
        <circle
          cx="1.968"
          cy="1.968"
          r="1.968"
          data-name="Ellipse 65"
          transform="translate(11.811)"
        ></circle>
        <circle
          cx="1.968"
          cy="1.968"
          r="1.968"
          data-name="Ellipse 64"
          transform="translate(5.905)"
        ></circle>
      </g>
    </svg>
  );
}
